module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "forum-post-list"
  }, _vm._l((_vm.posts), function(post, index) {
    return _c('li', {
      key: post.id,
      class: _vm.getLiClass(post),
      attrs: {
        "id": 'post_' + post.id
      }
    }, [_c('ForumPost', {
      attrs: {
        "post": post,
        "postUrl": _vm.getPostUrl(post),
        "sourcePost": _vm.getSourcePost(post),
        "sourcePostLoading": _vm.isSourcePostLoading(post),
        "answerPost": _vm.getAnswerPost(post),
        "answerPostLoading": _vm.isAnswerPostLoading(post),
        "canShare": true,
        "canLike": true,
        "canReply": true,
        "canEdit": _vm.thread.canEditPost(post.id),
        "canDelete": _vm.thread.canDeletePost(post.id),
        "canSolve": _vm.thread.canEditThread(),
        "isLiked": _vm.isPostLiked(post),
        "isAnswer": _vm.isPostAnswer(post),
        "isEditing": _vm.isEditingPost(post.id),
        "isReplyingTo": _vm.hasReplyToPost(post.id)
      },
      on: {
        "edit": function($event) {
          _vm.startEditingPost(post.id)
        },
        "cancel": function($event) {
          _vm.stopEditingPost(post.id)
        },
        "save": function($event) {
          _vm.updatePost(post.id, $event)
        },
        "reply": function($event) {
          _vm.startReplyToPost(post.id)
        },
        "like": function($event) {
          _vm.likePost(post.id)
        },
        "unlike": function($event) {
          _vm.unlikePost(post.id)
        },
        "delete": function($event) {
          _vm.deletePost(post.id)
        },
        "solve": function($event) {
          _vm.solveThread(post.id)
        },
        "unsolve": function($event) {
          _vm.unsolveThread(post.id)
        },
        "go-source-post": function($event) {
          _vm.goToPost(post.sourcePostId)
        },
        "go-answer-post": function($event) {
          _vm.goToAnswerPost()
        }
      }
    }, [_c('template', {
      attrs: {
        "slot": "saveEditorLabel"
      },
      slot: "saveEditorLabel"
    }, [_vm._v("\n                Update\n            ")])], 2), _vm._v(" "), (_vm.hasReplyToPost(post.id)) ? _c('div', {
      staticClass: "forum-post-reply"
    }, [_c('ForumPost', {
      attrs: {
        "post": _vm.getReplyToPost(post.id),
        "isEditing": true
      },
      on: {
        "cancel": function($event) {
          _vm.closeReplyToPost(post.id)
        },
        "save": function($event) {
          _vm.saveReplyToPost(post.id, $event)
        }
      }
    }, [_c('template', {
      attrs: {
        "slot": "saveEditorLabel"
      },
      slot: "saveEditorLabel"
    }, [_vm._v("\n                    Post reply\n                ")])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.isBeginningOfThread && index === 0) ? _c('ForumThreadSummary', {
      attrs: {
        "thread": _vm.thread.thread,
        "canEdit": _vm.thread.canEditThread(),
        "isEditing": _vm.isEditingSummary,
        "termTypes": _vm.summaryTermTypes,
        "pathIds": _vm.summaryPathIds,
        "assignmentIds": _vm.summaryAssignmentIds,
        "tagNames": _vm.summaryTagNames
      },
      on: {
        "update:termTypes": function($event) {
          _vm.summaryTermTypes = $event
        },
        "update:pathIds": function($event) {
          _vm.summaryPathIds = $event
        },
        "update:assignmentIds": function($event) {
          _vm.summaryAssignmentIds = $event
        },
        "update:tagNames": function($event) {
          _vm.summaryTagNames = $event
        },
        "edit": function($event) {
          _vm.startEditingSummary()
        },
        "cancel": function($event) {
          _vm.stopEditingSummary()
        },
        "save": function($event) {
          _vm.updateThread()
        },
        "go-last-post": function($event) {
          _vm.goToLastPost()
        }
      }
    }) : _vm._e()], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b25084ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/post-list.vue
// module id = 2117
// module chunks = 2